import { LoadingIcon } from "@components/library/Icons";
import { classNames } from "@components/library/utils/classNames";

interface Props {
  secondary?: true;
  inInput?: boolean;
  loading?: boolean;
}

const CTAButton = ({
  secondary,
  inInput,
  loading,
  children,
}: React.PropsWithChildren<Props>) => {
  return (
    <button
      type="submit"
      className={classNames(
        "group relative inline-flex select-none items-center justify-center font-bold", // Base
        // size=32 if in input
        inInput && "gap-8 text-14-16",
        inInput && "py-8 px-12",
        // size=40 if secondary, otherwise size=52
        !inInput && (secondary ? "gap-12 text-14-16" : "gap-16 text-18-24"),
        // !inInput && (secondary ? "py-12 px-16" : "py-[12px] px-20"),
        !inInput && (secondary ? "py-12" : "py-[12px]"),
        "focus:outline-none focus:ring",

        // Custom padding
        !inInput && !secondary && (loading ? "pl-16 pr-16" : "px-32"),
        !inInput && secondary && (loading ? "pl-12 pr-12" : "px-24"),
        // Custom colours
        secondary
          ? "bg-blue-300 text-blue-800 hover:bg-blue-400 focus:ring-blue-300 active:bg-blue-400"
          : "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-300 active:bg-blue-700",
        "dark:bg-gray-400 dark:text-black dark:hover:bg-gray-300 dark:focus:ring-gray-800 dark:active:bg-gray-300",
        "whitespace-nowrap",
        loading && "pointer-events-none"
      )}
      disabled={loading}
    >
      {children}
      {!inInput && loading && (
        <LoadingIcon className={secondary ? "h-12 w-12" : "h-16 w-16"} />
      )}
    </button>
  );
};

export default CTAButton;
